// extracted by mini-css-extract-plugin
export default {"shareSheet":"styles_shareSheet__hr6vj","item":"styles_item__rjIKd","active":"styles_active__dCAh9","divider":"styles_divider__8XKIj"};